var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "header" }, [
        _c("i", { staticClass: "far fa-check-square" }),
        _vm._v(" "),
        _c("h5", { staticClass: "d-inline mx-2" }, [
          _vm._v(" " + _vm._s(_vm.$t("txtTasks")) + " ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "progress" }, [
        _c("div", {
          staticClass: "progress-bar",
          style: {
            width: _vm.taskProgress + "%",
            "background-color":
              _vm.taskProgress === 100 ? "rgb(97, 189, 79)" : "#4e73df"
          },
          attrs: {
            role: "progressbar",
            "aria-valuenow": _vm.taskProgress,
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-1" },
        [
          _vm._l(_vm.card.taskItems, function(task) {
            return _c("Task", {
              key: task.id,
              attrs: {
                task: task,
                readonly: _vm.readonly,
                lockeddown: _vm.lockeddown
              },
              on: {
                toggle: _vm.taskToggle,
                edit: _vm.taskEdit,
                remove: _vm.taskDelete
              }
            })
          }),
          _vm._v(" "),
          _c("TaskItemModal", {
            ref: "taskItemModal",
            attrs: { state: _vm.state }
          })
        ],
        2
      ),
      _vm._v(" "),
      !_vm.readonly && !_vm.lockeddown
        ? [
            _vm.newTaskItem === null
              ? [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default btn-outline-secondary",
                      on: {
                        click: function($event) {
                          _vm.newTaskItem = ""
                          _vm.$nextTick(() => _vm.$refs.taskNew.focus())
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("txtAddTaskItem")) +
                          "\n      "
                      )
                    ]
                  )
                ]
              : [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newTaskItem,
                          expression: "newTaskItem"
                        }
                      ],
                      ref: "taskNew",
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("txtAddTaskItem")
                      },
                      domProps: { value: _vm.newTaskItem },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.taskCreate.apply(null, arguments)
                        },
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.newTaskItem = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default btn-success",
                          attrs: { type: "button" },
                          on: { click: _vm.taskCreate }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("btnAdd")) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default btn-outline-secondary",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.newTaskItem = null
                            }
                          }
                        },
                        [_vm._v("×\n          ")]
                      )
                    ])
                  ])
                ]
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }